var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "dropdown-item",
      attrs: { type: "button" },
      on: { click: _setup.setPref },
    },
    [
      _c("span", {
        staticClass: "me-2",
        class: {
          "bi-square": !_setup.twigMode,
          "bi-check-square": _setup.twigMode,
        },
      }),
      _vm._v("\n    Highlight Twig code\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }